import { USE_YN } from '../../shared/config/system.config';
import {
    TOAST_MESSAGES,
    VALIDATION_MESSAGES,
    DEFAULT_VALUE_FIELDS,
    MAX_VALUE_FIELDS,
} from '../constants/commonCode.constants';

export type CommonCodeFormItem = {
    id: string;
    comCode: string;
    comCdName: string;
    comSeqno: string;
    seqNo?: number;
    useYn: string;
    val1: string;
    val2: string;
    val3: string;
    val4: string;
    val5: string;
    visibleValueFields: number;
};

export type GroupFormData = {
    grpCode: string;
    grpName: string;
    grpVal: string;
    seqNo?: number;
};

export const createEmptyCodeItem = (): CommonCodeFormItem => ({
    id: `code-${Date.now()}-${Math.random()}`,
    comCode: '',
    comCdName: '',
    comSeqno: '',
    useYn: USE_YN.YES,
    val1: '',
    val2: '',
    val3: '',
    val4: '',
    val5: '',
    visibleValueFields: DEFAULT_VALUE_FIELDS,
});

export const createEmptyGroupFormData = (): GroupFormData => ({
    grpCode: '',
    grpName: '',
    grpVal: '',
    seqNo: undefined,
});

// 코드값 필드 삭제: 클릭한 필드를 제거하고 이후 필드를 앞으로 당긴다
export const removeValueFieldAt = (
    code: CommonCodeFormItem,
    fieldIndex: number  // 1-based
): Partial<CommonCodeFormItem> => {
    const vals = [code.val1, code.val2, code.val3, code.val4, code.val5];
    vals.splice(fieldIndex - 1, 1);
    vals.push('');
    return {
        visibleValueFields: Math.max(0, code.visibleValueFields - 1),
        val1: vals[0], val2: vals[1], val3: vals[2], val4: vals[3], val5: vals[4],
    };
};

// 코드값 필드 추가
export const addValueField = (
    code: CommonCodeFormItem
): Partial<CommonCodeFormItem> => ({
    visibleValueFields: Math.min(code.visibleValueFields + 1, MAX_VALUE_FIELDS),
});

/** @deprecated removeValueFieldAt / addValueField 로 대체 */
export const getToggledValueFieldState = (
    code: CommonCodeFormItem,
    fieldIndex: number
): Partial<CommonCodeFormItem> => {
    if (fieldIndex < code.visibleValueFields) {
        return removeValueFieldAt(code, fieldIndex);
    }
    return addValueField(code);
};

export const validateForm = (
    formData: GroupFormData,
    commonCodes: CommonCodeFormItem[]
): string | null => {
    if (!formData.grpCode.trim()) return VALIDATION_MESSAGES.GRP_CODE_REQUIRED;
    if (!formData.grpName.trim()) return VALIDATION_MESSAGES.GRP_NAME_REQUIRED;

    for (let i = 0; i < commonCodes.length; i++) {
        const code = commonCodes[i];
        if (!code.comCode.trim()) return VALIDATION_MESSAGES.COM_CODE_REQUIRED(i + 1);
        if (!code.comCdName.trim()) return VALIDATION_MESSAGES.COM_NAME_REQUIRED(i + 1);
    }

    return null;
};

export { TOAST_MESSAGES, VALIDATION_MESSAGES, DEFAULT_VALUE_FIELDS, MAX_VALUE_FIELDS };
